import { AccountStatus } from '../../constants';
import BaseApi from './BaseApi';

export type Kaiin = {
  kaiinName: string;
  companyId: string;
  kaiinLogo: string;
  accountStatus?: AccountStatus;
  isOutsideBusinessHour: boolean;
};

/**
 * 会員一覧検索API。
 */
class SearchKaiinListApi extends BaseApi {
  async get(params: string[]): Promise<Kaiin[]> {
    return params?.filter(Boolean).length
      ? await this.execute('athomeSearchKaiinListApi', {
          method: 'POST',
          body: {
            companyIdList: params?.join(',') || ''
          }
        })
          .then(({ result }) => result.kaiinList as Kaiin[])
          .catch(() => [])
      : new Promise((resolve) => resolve([]));
  }
}

export default SearchKaiinListApi;
